export default __webpack_public_path__ + "static/media/Banner-V-Vinyl.e9698dd0.jpg";